import React from 'react';
import { withStyles } from '@material-ui/core';
import { Stack } from '@mui/material';
import styles from './styles';
import BackofficePageTitle from '../../../Components/BackofficePageTitle/BackofficePageTitle';
import VFormCard from '../../../Venti-UI-Kit/VForms/VFormCard/VFormCard';
import DraggableList from '../../../Components/DraggableList/DraggableList';
import DraggableRecommendationListItem from './DraggableRecommendationListItem/DraggableRecommendationListItem';
import Button from '../../../Components/Buttons/Button/Button';
import { useRecommendationLists } from './hook';

const RecommendationListsPage = ({ classes }) => {
  const { lists, enableSaveButton, handleDragEnd, handleReOrderLists, getLists } =
    useRecommendationLists();

  return (
    <Stack className={classes.pageContentContainer}>
      <BackofficePageTitle mainTitle="Listas de Recomendaciones" />
      <VFormCard
        label="Listas de Recomendaciones"
        icon="list"
        rightButton={
          <Button
            variant="contained"
            fullwidth={false}
            title="Guardar"
            onClick={handleReOrderLists}
            disabled={!enableSaveButton}
            size="small"
            width={100}
          />
        }
      >
        {lists.length > 0 && (
          <DraggableList
            items={lists}
            onDragEnd={handleDragEnd}
            renderItem={({ item }) => (
              <DraggableRecommendationListItem list={item} getLists={getLists} />
            )}
          />
        )}
      </VFormCard>
      <Button
        variant="contained"
        fullwidth={false}
        title="Crear nueva"
        href="/backoffice/admin/listasDeRecomendacion/crear"
        width={300}
      />
    </Stack>
  );
};

export default withStyles(styles)(RecommendationListsPage);
